import heic2any from 'heic2any'

export function convertHeicToJpg(file) {

    const filename = file.name;
    const fileType = (file.type || '').toLowerCase();
    const ext = filename.split('.').pop()?.toLowerCase() || '';

    // Reset previous preview
    const revoke = (el) => { try { el.src && URL.revokeObjectURL(el.src); } catch (_) { } };
    revoke(imgEl);

    const isHeic = () =>  fileType === 'image/heic' ||fileType === 'image/heif' || ext === 'heic' || ext === 'heif';

    try {

        if (isHeic()) {
            // Convert HEIC -> JPEG (quality 0.9). You can switch to 'image/png' if preferred.
            console.log("In HEIC Conversion")
            const srcData = convertHeic(file)
            if (srcData) {
                return srcData
            }
            else { return null }
        }
    } catch (err) {
        console.error('Preview error:', err);
        // Graceful fallback: tell user we couldn’t preview; maybe show filename only
        imgEl.style.display = 'block';
        pdfEl.style.display = 'none';
        figCaption.textContent = `${filename} — Preview not available`;
    }
}

const convertHeic = async()=>{
    const blob = await heic2any({
    blob: file,
    toType: "image/jpeg", // or 'image/png'
    quality: 0.9,
    });
    const outBlob = blob instanceof Blob ? blob : new Blob([blob], { type: "image/jpeg" });
    const url = URL.createObjectURL(outBlob);
    return url 
}